// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import styles from "./styles.css";

export default function MarkdownContent({ children, className }) {
    return <div className={cn(styles.MarkdownContent, className)}>{children}</div>;
}

MarkdownContent.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};
